export enum SortOptionEnum {
  PRICE = 'price-excludes-shipping',
  PRICE_INCLUDES_SHIPPING = 'price_includes_shipping',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.PRICE_INCLUDES_SHIPPING;
